import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import 'hammerjs';
import { defineCustomElements as jeepSqlite} from 'jeep-sqlite/loader';
// filepath: d:\APPS\cmc_app\src\main.ts
import { register } from 'swiper/element/bundle';
register();

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
jeepSqlite(window);
/*
console.log(environment)
*/
if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () {};
    window.console.info = function () {};
    window.console.error = function () {};
    window.console.debug = function () {};
    window.console.warn = function () {};
    window.console.trace = function () {};
    window.console.group = function () {};
    window.console.groupEnd = function () {};
  }
}


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => defineCustomElements(window))
  .catch(err => console.log(err)
 );

